import { Cropper } from 'vue-advanced-cropper'

export default {
    name: 'CropImg',
    data() {
        return {
            img: 'https://images.pexels.com/photos/226746/pexels-photo-226746.jpeg',

        }
    },
    props: {
        imageSrc: {
            type: String,
            default: _ => {
                return ''
            }
        },
        imageType: {
            type: String,
            default: _ => {
                return 'image/jpg'
            }
        },
        loading: {
            type: Boolean,
            default: _ => {
                return false
            }
        }
    },
    components: {
        Cropper
    },
    methods: {
        submit() {
            const {coordinates, canvas} = this.$refs.cropper.getResult();
            this.$emit('result', { canvas: canvas});

            // If Blob file is needed in the future this is how is done
            // canvas.toBlob((blob) => {
            //     let url = canvas.toDataURL(this.imageType);
            //     this.$emit('result', { url: url, blob: blob});
            // });
        },
        pixelsRestriction({minWidth, minHeight, maxWidth, maxHeight, imageWidth, imageHeight}) {
			return {
				minWidth: minWidth,
				minHeight: minHeight,
				maxWidth: maxWidth,
				maxHeight: maxHeight,
			}
		},
    }
}
